$(document).on("click", ".prd_popup_btn", function () {
  var inner_data = $(this).find(".block_how_much_storage_inner").html();
  $(".product_popup_data").append(inner_data);
  $(".itg_product_template_popup").addClass("active");
  $("html,body").addClass("blog_popup_active");
});

$(document).on("click", ".prd_popup_btn_sam-jane", function () {
  var inner_data_de = $(this).find(".block_how_much_storage_inner_de").html();
  var inner_data_en = $(this).find(".block_how_much_storage_inner_en").html();
  if (window.location.href.includes('https://de.elitescreens.eu/')) {
    $(".product_popup_data").append(inner_data_de);
  } else {
    $(".product_popup_data").append(inner_data_en);
  }
  
  $(".itg_product_template_popup").addClass("active");
  $("html, body").addClass("blog_popup_active");
});

$(document).on("click", ".product_popup_data .popup_close_btn", function () {
  $(".product_popup_data").empty();
  $(".itg_product_template_popup").removeClass("active");
  $("html,body").removeClass("blog_popup_active");
});

$(document).on("click", ".choose_model_section", function () {
  var inner_data = $(this).find(".choose_model_content_main").html();
  // console.log(inner_data);
  $(".product_popup_data").append(inner_data);
  $(".itg_product_template_popup").addClass("active screen_model_btn");
  $("body").addClass("blog_popup_active");
});
$(document).on("click", ".product_popup_data .popup_close_btn", function () {
  $(".product_popup_data").empty();
  $(".itg_product_template_popup").removeClass("active screen_model_btn");
  $("body").removeClass("blog_popup_active");
});

$(document).on('click', '.screen__material--label', function() {
  const variantMetaData = $(this).find('.variant_meta_data').html();
  $('.choose_model_section .first.variant_meta_data_clone').html(variantMetaData);
});

$(document).on("click", ".itg_product_template_popup", function (event) {
  if (!$(event.target).closest('.product_popup_data').length) {
    $(".product_popup_data").empty();
    $(".itg_product_template_popup").removeClass("active screen_model_btn");
    $("body").removeClass("blog_popup_active");
  }
});


$(document).on("keydown", function (event) {
  if (event.key === "Escape") {
    closePopup();
  }
});

function closePopup() {
  $(".product_popup_data").empty();
  $(".itg_product_template_popup").removeClass("active screen_model_btn");
  $("body").removeClass("blog_popup_active");
}

document.addEventListener('DOMContentLoaded', function() {
    const knobs = document.querySelectorAll('.one-xray .knob');
    if (knobs.length < 2) {
        return;
    }

    const xraySlider1knob = knobs[0];
    const xraySlider2knob = knobs[1];
    const knobOffset = window.innerHeight / 5;

    function checkInView(element, { offset = 0 } = {}) {
        const rect = element.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        return rect.top <= windowHeight - offset && rect.bottom >= offset;
    }

    function throttle(delay, callback) {
        let lastCall = 0;
        return function (...args) {
            const now = new Date().getTime();
            if (now - lastCall >= delay) {
                lastCall = now;
                callback(...args);
            }
        };
    }

    function handlePageScroll() {
        function triggerSliderAnimationIfInView(knobNode) {
            if (knobNode && checkInView(knobNode, { offset: knobOffset })) {
                const container = knobNode.closest('.one-xray');
                if (container && !container.classList.contains('slider-center')) {
                    container.classList.add('slider-center');
                }
            }
        }
        triggerSliderAnimationIfInView(xraySlider1knob);
        triggerSliderAnimationIfInView(xraySlider2knob);
    }

    const throttledHandlePageScroll = throttle(200, handlePageScroll);
    document.addEventListener('scroll', throttledHandlePageScroll, false);
});

document.addEventListener('DOMContentLoaded', () => {
  const var_title = document.querySelector('.cs__variant--title');
  const legend = document.querySelectorAll(".form__label span");
  const stickyAtc = document.querySelector('.cs__sticky--atc button.product-form__submit');
  const stickyAtcContainer = document.querySelector('.cs__sticky--atc');
  const mainAtcButton = document.querySelector('.product-form__submit');

  const manualTrigger = document.querySelector('#manual-popup-trigger');
  const chatToggle = document.querySelector('#chat-toggle');
  
  if (var_title) {
    var_title.innerHTML = Array.from(legend).map((item) => item.innerText).join('/');
  }

  if (!mainAtcButton || !stickyAtcContainer || !manualTrigger || !chatToggle) return;

  const updateButtonPosition = (isSticky) => {
    const isMobile = window.innerWidth <= 576;
    
    const baseOffset = isMobile 
      ? parseInt(manualTrigger.dataset.bottomMobile) 
      : parseInt(manualTrigger.dataset.bottomDesktop);
    
    const chatBaseOffset = isMobile 
      ? parseInt(chatToggle.dataset.bottomMobile) 
      : parseInt(chatToggle.dataset.bottomDesktop);

    if (isSticky) {
      setTimeout(function() {
        const stickyHeight = stickyAtcContainer.offsetHeight;
        manualTrigger.style.bottom = (baseOffset + stickyHeight) + 'px';
        chatToggle.style.bottom = (chatBaseOffset + stickyHeight) + 'px';
      }, 500);
    } else {
      manualTrigger.style.bottom = baseOffset + 'px';
      chatToggle.style.bottom = chatBaseOffset + 'px';
    }
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const shouldBeSticky = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        
        if (shouldBeSticky) {
          stickyAtcContainer.classList.add('active');
          updateButtonPosition(true);
        } else {
          stickyAtcContainer.classList.remove('active');
          updateButtonPosition(false);
        }
      });
    },
    { threshold: 0 }
  );

  observer.observe(mainAtcButton);

  stickyAtc.addEventListener("click", () => mainAtcButton.click());
  
  window.addEventListener('resize', () => {
    const isSticky = stickyAtcContainer.classList.contains('active');
    updateButtonPosition(isSticky);
  });
});


